export default {
  props: ['data'],
  data () {
    return {
      isRenderingChart: false
    }
  },
  mounted () {
    this.renderFromData()
  },
  beforeDestroy () {
    this.isRenderingChart = false
    if (this.$data._chart) {
      this.$data._chart.destroy()
      this.$data._chart = null
    }
  },
  watch: {
    // Reference-only: Chart.js mutates options/datasets in place. A deep watcher
    // re-enters renderFromData and freezes the tab (especially on financialView changes).
    data () {
      this.renderFromData()
    }
  },
  methods: {
    renderFromData () {
      if (!this.data || !this.data.report || this.isRenderingChart) {
        return
      }

      this.isRenderingChart = true

      try {
        if (this.$data._chart) {
          this.$data._chart.destroy()
          this.$data._chart = null
        }

        this.renderChart(this.data.report, this.data.options)

        this.$nextTick(() => {
          if (this.$data._chart) {
            this.$data._chart.resize()
          }
          this.isRenderingChart = false
        })
      } catch (error) {
        this.isRenderingChart = false
        throw error
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/charts/chartRendererMixin.js